import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { API_COMMENT } from 'constants/api';
import { generateURL } from 'helpers';
import { ScorecardsActionStoreArgument } from 'store/interfaces';
import { updateScorecardCommentsThread } from 'store/scorecards';
import { storeName } from '../config';
import { Comment, Thread } from '../interfaces';

export const addScorecardComment = createAsyncThunk<
  Comment,
  {
    thread: Thread;
    content: string;
    scorecardId: number;
    goalId: number;
    subgoalId?: number;
    store: ScorecardsActionStoreArgument;
  }
>(
  `${storeName}/addScorecardComment`,
  ({ thread, content, scorecardId, goalId, subgoalId, store }, thunkAPI) =>
    api.axios
      .post<Comment>(generateURL(API_COMMENT, { threadId: thread.id }), {
        content,
      })
      .then((res) => {
        thunkAPI.dispatch(
          updateScorecardCommentsThread({
            store,
            scorecardId,
            goalId,
            subgoalId,
            thread: { id: thread.id, totalMessages: 0 },
            change: 1,
          }),
        );
        return res.data;
      })
      .catch((e) => thunkAPI.rejectWithValue(e.response?.data)),
);
